// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.rem(1.25)),
        tl: {
          hd: BrowserStyle.flexShrink(0.0),
          tl: {
            hd: BrowserStyle.flexBasis(BrowserStyle.rem(2.5)),
            tl: {
              hd: BrowserStyle.height(BrowserStyle.rem(2.5)),
              tl: {
                hd: BrowserStyle.width(BrowserStyle.rem(2.5)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var Styles = {
  image: image
};

function BrowserComponents_ProfilePicture(Props) {
  var className = Props.className;
  var profilePicture = Props.profilePicture;
  return Relude_Option.fold(React.createElement("div", {
                  className: BrowserStyle.Utils.extendBaseStyle(image, className)
                }), (function (param) {
                return React.createElement("img", {
                            className: BrowserStyle.Utils.extendBaseStyle(image, className),
                            src: param.imageUrl
                          });
              }), profilePicture);
}

var make = BrowserComponents_ProfilePicture;

exports.Styles = Styles;
exports.make = make;
/* image Not a pure module */
